import * as React from 'react';
import { createContext, useContext, useReducer, useCallback, useRef, ReactElement } from 'react';

import { actionHandler } from './middlewares';
import mainReducer, { initialState } from './reducers';
import { ActionResult } from './types';

const AuthContext = createContext(initialState.authStore);
const AssetsContext = createContext(initialState.assetsStore);
const DispatchContext = createContext<React.Dispatch<ActionResult>>(null);

export const useAuthState = () => useContext(AuthContext);
export const useAssetsState = () => useContext(AssetsContext);
export const useStoreDispatch = () => useContext(DispatchContext);

export default function Provider({ children }: { children: React.ReactNode }): ReactElement {
    const [state, dispatchBase] = useReducer(mainReducer, initialState);
    const stateRef = useRef(state);
    stateRef.current = state;
    const dispatch = useCallback(
        (action: ActionResult) => actionHandler(dispatchBase, stateRef.current)(action),
        [],
    );

    return (
        <DispatchContext.Provider value={dispatch}>
            <AuthContext.Provider value={state.authStore}>
                <AssetsContext.Provider value={state.assetsStore}>
                    {children}
                </AssetsContext.Provider>
            </AuthContext.Provider>
        </DispatchContext.Provider>
    );
}
